<template>
    <div class="box">
        <proposal-form :campaign="campaign" :proposal="proposal" @proposal-complete="finish" @request-error="handleRequestError" @notify-error="handleNotifyError"/>
    </div>
</template>
<script>
    import ProposalForm from './ProposalForm';
    import CampaignProposalMixin from './CampaignProposalMixin';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'Proposal',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignProposalMixin,
        ],

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            ProposalForm,
        },

        /**
         * The component methods
         *
         * @type {Object}
         */
        methods: {
            /**
             * Finish the proposal submission
             */
            finish(campaign) {
                this.$root.reloadContact('proposals').then(() => {
                    this.$emit('done');
                    this.$parent.show_proposal = false;
                    this.$root.go('proposals', { campaign_id: campaign.id });
                });
            },
            handleRequestError(res){
                this.$requestErrors(res)
            },
            handleNotifyError(message){
                this.$notifyError(message);
            }
        },
    }
</script>